import React from 'react';
import UncheckIcon from 'assets/livenicons/uncheck.svg';

import styles from './styles.module.scss';

export const LifeWithoutLiven = () => {
  return (
    <div className={styles.checkoutAchieveBoxWrapper}>
      <div className={styles.checkoutAchieveBox}>
        <h6 className={styles.title}>How life might be without Loóna</h6>
        <div className={styles.checklist}>
          <p className={styles.checklistItem}>
            <img src={UncheckIcon} alt="" />
            <span>Feeling guilty for not being productive</span>
          </p>

          <p className={styles.checklistItem}>
            <img src={UncheckIcon} alt="" />
            <span>Scrolling on social media in the middle of a task</span>
          </p>

          <p className={styles.checklistItem}>
            <img src={UncheckIcon} alt="" />
            <span>Feeling uneasy when you have free time</span>
          </p>

          <p className={styles.checklistItem}>
            <img src={UncheckIcon} alt="" />
            <span>Feeling rushed at work</span>
          </p>

          <p className={styles.checklistItem}>
            <img src={UncheckIcon} alt="" />
            <span>Always checking phone for messages or emails</span>
          </p>

          <p className={styles.checklistItem}>
            <img src={UncheckIcon} alt="" />
            <span>Lack of time for self care</span>
          </p>

          <p className={styles.checklistItem}>
            <img src={UncheckIcon} alt="" />
            <span>Feeling tired and overwhelmed during the day</span>
          </p>
        </div>
      </div>
    </div>
  );
};
